import OrgType from '@/constants/orgType.constant';
export const CommunityRoles = {
  Admin: 'community_admin',
  Member: 'member',
};

export const CommunityTypes = {
  NonProfit: 'npo',
  Business: 'business',
  ChangeMakers: 'change-makers',
};

export const isNekiAdmin = (user) => {
  // return user.activeCommunity?.role === CommunityRoles.Admin && user.activeCommunity?.name === 'Neki';
  return user?.isNekiAdmin || false;
};
export const isCompanyAdmin = (user) => {
  return (
    user.activeCommunity?.role === CommunityRoles.Admin &&
    [OrgType.Business, OrgType.ChangeMakers].includes(
      user.activeCommunity?.orgType,
    )
  );
};

export const isNonProfitAdmin = (user) => {
  return (
    user.activeCommunity?.role === CommunityRoles.Admin &&
    user.activeCommunity?.orgType === OrgType.NonProfit
  );
};
export const isCompanyUser = (user) => {
  return (
    user.activeCommunity?.role === CommunityRoles.Member &&
    [OrgType.Business, OrgType.ChangeMakers].includes(
      user.activeCommunity?.orgType,
    )
  );
};

export const isNonProfitUser = (user) => {
  return (
    user.activeCommunity?.role === CommunityRoles.Member &&
    user.activeCommunity?.orgType === OrgType.NonProfit
  );
};

export const getUserRole = (user) => {
  if (isNonProfitAdmin(user)) {
    return 'non_profit_admin';
  } else if (isCompanyAdmin(user)) {
    return 'company_admin';
  } else if (isNonProfitUser(user)) {
    return 'non_profit_user';
  } else if (isCompanyUser(user)) {
    return 'company_user';
  } else if (isNekiAdmin(user)) {
    return 'neki_admin';
  }
  return 'user';
};
